module.exports = __webpack_public_path__ + "static/media/Diagnoses_Active.766c1184.png";